import $$ from 'cmn-utils'
import trigger from './trigger/index.js'
import execute from './execute/index.js'

const baseUrl = "/api/linkage/v2/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    changeState: (params) => {
        return $$.post(baseUrl + 'update-state', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },

    deviceLinkageList: (params) => {
        return $$.get(baseUrl + 'device-linkage-list', params)
    },
    updateEnable: (params) => {
        return $$.post(baseUrl + 'update-enable', params)
    },
    trigger,
    execute,
}